import React, { useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useCartStore, useUserStore, useCompanyStore } from 'stores';
//icons
import { RiCloseLine } from 'react-icons/ri';
// api
import { removeItemCart, deleteGiftCardCart } from 'api/ecommerce';
import { buildCartLineMutationPayload } from 'utils/bookCondition';
// helpers
import { detailTypeProductRedirect } from 'helpers';
//utils
import { formatCurrency } from 'utils/currencyFormatter';
//custom-hook
import useAssignedLibrary from 'utils/customHooks/useAssignedLibrary';
// components
import Image from 'components/image';
// images
import notavaib from 'assets/img/preview.jpg';
import giftImageCard from 'assets/img/giftCard.jpg';

const MiniCart = () => {
  const { items, giftCard, hasGiftCard, removeItem, removeGiftCard } = useCartStore();
  const { isLogged } = useUserStore();
  const { shipping_cost, shipping_cost_islands, min_purchase_for_free_shipping } = useCompanyStore();
  const [modalShow, setModalShow] = useState(false);
  const [productsShow, setProductsShow] = useState(() => [items]);
  const { assignedLibrary} = useAssignedLibrary();

  const { t } = useTranslation(['cart']);

  const removeProductCart = async (item) => {
    if (isLogged) {
      const payload = buildCartLineMutationPayload(item);
      const { status, dataResponse } = await removeItemCart(payload);
      if (status === 200) {
        removeItem(item, shipping_cost, shipping_cost_islands, min_purchase_for_free_shipping);
      } else {
        console.log('error');
      }
    } else {
      removeItem(item, shipping_cost, shipping_cost_islands, min_purchase_for_free_shipping);
    }
  };

  const removeGiftCardCart = async () => {
    if (isLogged) {
      const payload = { item: giftCard };
      const { status, data } = await deleteGiftCardCart(payload);
      if (status === 200) {
        removeGiftCard();
      } else {
        console.log('error');
      }
    } else {
      removeGiftCard();
    }
  };


  useEffect(() => {
    if (items !== '' && items !== undefined) {
      setProductsShow(items);
    }
  }, [items]);


  const paintCartProducts = (item, index) => {
    return (
      <div key={`${item.id}-${item.book_condition ?? 'x'}`} className="cart-product" id={item.id}>
        <Row className="cart-product__item">
          <Col lg={3} className="px-2">
            <Link to={detailTypeProductRedirect(item, assignedLibrary )} onClick={() => setModalShow(false)}>
              <Image key={item.id} src={item.image} fallbackSrc={notavaib} height="100" />
            </Link>
          </Col>
          <Col lg={8} className="details px-2">
            <div className="details-title">
              <Link to={detailTypeProductRedirect(item, assignedLibrary)} onClick={() => setModalShow(false)}>
                {item?.title || item?.titulo}
              </Link>
            </div>
            {item.authors ? (
              <div className="details-author">
                <span>{item.authors.length > 0 ? item.authors[0].nombre_autor : ''}</span>
              </div>
            ) : (
              ''
            )}
            <div className="details-price" >
              <span className="quantity">
                {item.quantity} {item.quantity > 1 ? `${t('units')} X ` : `${t('unit')} X `}
              </span>
              <span className="unitPrice">{formatCurrency(Number(item.quantity) * (Number(item.unit_price ?? item.price) || 0))}</span>
            </div>
          </Col>
          <Col lg={1} className="px-2">
            <RiCloseLine className="icon-sm cursor-pointer" onClick={() => removeProductCart(item)} />
          </Col>
        </Row>
      </div>
    );
  };

  const paintGiftCard = () => {
    return (
      <div className="cart-product">
        <Row className="cart-product__item">
          <Col lg={3} className="px-2">
            <Image src={giftImageCard} className="style-gift-card" />
          </Col>
          <Col lg={8} className="details px-2">
            <div className="details-title">{t('giftcard')}</div>
            <div className="details-price ">
              <span className="quantity ">{`1 ${t('unit')} X `}</span>
              <span className="unitPrice">{formatCurrency(giftCard?.discount_amount || 0)}</span>
            </div>
          </Col>
          <Col lg={1} className="px-2">
            <RiCloseLine className="icon-sm cursor-pointer" onClick={() => removeGiftCardCart()} />
          </Col>
        </Row>
      </div>
    );
  };

  return (
    <div className="cart">
      {productsShow !== undefined && productsShow.map((item, index) => paintCartProducts(item, index))}
      {hasGiftCard && paintGiftCard()}
    </div>
  );
};

export default MiniCart;
